export const WHITE = 0;
export const PRIMARY = 1;
export const SECONDARY = 2;
export const TERTIARY = 3;
export const MAIN = 4;
